export const openPrioritiesDrawer = (data) => {
    return {
        type: 'PRIORITIES_DRAWER',
        payload: true,
        data: data
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Item/components/Priority/actions.js